import { googleFontFromValue } from '@realadvisor/common-types';

export type GoogleFont = readonly [family: string, generic: string];

export type StandardFont = { value: string; label: string };

export const MAX_FONT_RESULTS = 100;

export const STANDARD_FONTS: StandardFont[] = [
  { value: 'default', label: 'Arial' },
  { value: 'Helvetica', label: 'Helvetica' },
  { value: 'Georgia', label: 'Georgia' },
  { value: 'Verdana', label: 'Verdana' },
  { value: 'Tahoma', label: 'Tahoma' },
  { value: 'Trebuchet MS', label: 'Trebuchet MS' },
  { value: 'Times New Roman', label: 'Times New Roman' },
  { value: 'Courier New', label: 'Courier New' },
];

export const googleFontsFromRows = (
  rows: readonly (readonly string[])[],
): GoogleFont[] =>
  rows.flatMap(([family, generic]) =>
    family != null && generic != null ? [[family, generic] as const] : [],
  );

export const fontLabel = (value: string): string =>
  STANDARD_FONTS.find(font => font.value === value)?.label ??
  googleFontFromValue(value) ??
  value;

const rank = (name: string, query: string): number | null => {
  const index = name.toLowerCase().indexOf(query);
  if (index === -1) {
    return null;
  }
  return index === 0 ? 0 : 1;
};

export const filterFonts = <T>(
  fonts: readonly T[],
  getName: (font: T) => string,
  rawQuery: string,
  limit = MAX_FONT_RESULTS,
): T[] => {
  const query = rawQuery.trim().toLowerCase();
  if (query === '') {
    return fonts.slice(0, limit);
  }
  const prefix: T[] = [];
  const inside: T[] = [];
  for (const font of fonts) {
    const found = rank(getName(font), query);
    if (found === 0) {
      prefix.push(font);
    } else if (found === 1) {
      inside.push(font);
    }
  }
  return [...prefix, ...inside].slice(0, limit);
};
